import { connect } from 'react-redux';
import { createCollection } from '../../../../CollectionPanel/redux/actionCreators';
import { getNewFolderNameBlacklist, getIsNewCollectionSaving } from '../../../../CollectionPanel/redux/selectors';
const mapStateToProps = (state, { isPrivateCollections })=>({
        folderNameBlacklist: getNewFolderNameBlacklist(state, isPrivateCollections),
        isSaving: getIsNewCollectionSaving(state)
    });
const mapDispatchToProps = {
    createCollection
};
export default connect(mapStateToProps, mapDispatchToProps);
